import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'
import type { AiqIndividualReportResponse } from '@quebon/shared-learning'

export const aiqApi = {
  /**
   * Get individual AIQ comparison report (Pre vs Post)
   */
  getIndividualReport: (productId: number) => {
    const params = new URLSearchParams({ productId: String(productId) })
    return apiClient.get<ApiResponse<AiqIndividualReportResponse>>(`/aiq/report/individual?${params}`)
  },
}
